<template>
  <el-breadcrumb separator="/" class="app-breadcrumb">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="item.path">
        <span v-if="index === breadcrumbs.length - 1" class="no-link">
          {{ item.title }}
        </span>
        <router-link v-else :to="item.path">{{ item.title }}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { menuTree, findParentIndex } from '@/config/menu'

export default {
  name: 'Breadcrumb',
  computed: {
    breadcrumbs() {
      const path = this.$route.path
      const result = []
      // 查找一级菜单
      const pIndex = findParentIndex(menuTree, path)
      if (pIndex >= 0 && menuTree[pIndex]) {
        result.push({
          path: menuTree[pIndex].path,
          title: menuTree[pIndex].title,
        })
        // 查找二级菜单
        const children = menuTree[pIndex].children
        if (children) {
          const child = children.find(c => c.path === path)
          if (child) {
            result.push({ path: child.path, title: child.title })
          }
        }
      }
      // 兜底：至少显示当前路由 meta.title
      if (result.length === 0 && this.$route.meta && this.$route.meta.title) {
        result.push({ path, title: this.$route.meta.title })
      }
      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.app-breadcrumb {
  font-size: 14px;
  line-height: 50px;

  .no-link {
    color: rgba(0, 0, 0, 0.85);
    cursor: text;
  }

  a {
    color: rgba(0, 0, 0, 0.45);
    text-decoration: none;

    &:hover {
      color: #2C68FF;
    }
  }
}

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.25s;
}
.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(10px);
}
</style>
